import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { FileSystemCopySource } from 'app/model/pipeline/copysource/file-system.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { FileTypeSourceAdapter } from 'app/model/adapters/activities/copysource/file-type.source.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FileSystemCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        recursive: '*',
        maxConcurrentConnections: '*'
    }
})
export class FileSystemCopySourceAdapter extends CopySourceAdapter<FileSystemCopySource, Model.FileSystemSource> {
    protected override async _toResource(copySource: FileSystemCopySource): Promise<Model.FileSystemSource> {
        const result: Model.FileSystemSource = this.getCommonCopySourceProperties(copySource, 'FileSystemSource');
        FileTypeSourceAdapter.toSourceResource(copySource, result);
        return result;
    }

    protected override async _toModel(
        fileSystemSource: Model.FileSystemSource,
        copyActivity: CopyActivity
    ): Promise<FileSystemCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            FileSystemCopySource.MODEL,
            fileSystemSource,
            copyActivity
        ) as FileSystemCopySource;
        FileTypeSourceAdapter.toSourceModel(fileSystemSource, result);
        return result;
    }
}
